export const handleOpenTerms =(type) => {
    // 0 je termsOfUse
    // 1 je policy
    if(type === 0){
        return {
            termsOfUse: true,
            policy: false
        }
    } return {
        termsOfUse: false,
        policy: true
    }
}

export const handleCloseTerms = () => {
    return {
        termsOfUse: false,
        policy: false
    }
}
